import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IWellViewModel } from 'app/models/well/well.viewmodel';
import { HouseholdService } from 'app/services/household-service';
import { ToastrService } from 'ngx-toastr';
import { HouseholdAssociation } from 'app/models/household/household-association';
import { DialogEditHousingUnitComponent } from '../edit/units/housingunit-edit-dialog';
import { IHousehold } from 'app/models/household/household';
import { HousingUnitService } from 'app/services/housingunit-service';
import { HousingUnitAssociations } from 'app/models/housingunits/housing-unit-associations';
import { IHousingUnit } from 'app/models/housingunits/housing-unit';
import { DialogAssociateHouseholdToHousingUnitComponent } from './associate/associate-household-housingunit-dialog';
import { DialogAssociateHousingUnitToWellComponent } from './associate/associate-housingunit-well-dialog';
import { DialogEditHouseholdComponent } from '../edit/household-edit-dialog';
import { HouseholdAssociations } from 'app/models/household/household-associations';
import { OregonWellDataService } from 'app/services/oregon-well-data.service';
import { AuthService } from '@shared/auth/auth.service';

@Component({
  selector: 'housingunit-associations',
  templateUrl: './housingunit-associations.component.html',
  styleUrls: ['./housingunit-associations.component.scss']
})
export class HousingUnitAssociationsComponent implements OnInit {
  processing = false;
  associations: HousingUnitAssociations = null;
  housingUnitAssocations: HousingUnitAssociations = {
    households: [],
    housingUnit: undefined,
    housingUnits: [],
    wells: [],
    housingUnitStartDate: '',
    housingUnitEndDate: '',
    householdHousingUnitKey: 0,
    wellId: 0,
    createNewWell: false,
    newAddress1: '',
    newCity: '',
    newZip: '',
    newCounty: '',
    housingUnitId: 0,
    newContactName: ''
  };

  // Housing Unit Associations
  @Input('housingUnitId')
  housingUnitId: number = 0;
  @Input('housingUnits')
  housingUnits: boolean = false;
  dataSourceHousingUnits = new MatTableDataSource<IHousingUnit>();
  displayedColumnsHousingUnits: string[] = ['id', 'contactName', 'address1', 'city', 'zip', 'county', 'actions'];

  filterTableHousingUnits(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceWells.filter = value.trim().toLowerCase();
  }

  // Household Associations
  @Input('householdId')
  householdId: number = 0;
  @Input('households')
  households: boolean = false;
  displayedColumnsHouseholds: string[] = ['id', 'contactName', 'address1', 'city', 'zip', 'county', 'startDate', 'endDate', 'actions'];
  dataSourceHouseholds = new MatTableDataSource<IHousehold>();

  filterTableHouseholds(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceHouseholds.filter = value.trim().toLowerCase();
  }

  // Well Associations
  @Input('wellId')
  wellId: number = 0;
  @Input('wells')
  wells: boolean = false;
  displayedColumnsWells: string[] = ['id', 'wellAddress', 'city', 'state', 'zip', 'county', 'wellLog', 'tag', 'actions'];
  dataSourceWells = new MatTableDataSource<IWellViewModel>();

  filterTableWells(event: Event) {
    let value = (event.target as HTMLInputElement).value;
    this.dataSourceWells.filter = value.trim().toLowerCase();
  }

  @ViewChild('TablePaginatorHousehold') paginatorHousehold: MatPaginator;
  @ViewChild('TableSortHousehold') sortHousehold: MatSort;

  @ViewChild('TablePaginatorWell') paginatorWell: MatPaginator;
  @ViewChild('TableSortWell') sortWell: MatSort;
  
  @ViewChild('TablePaginatorHousingUnit') paginatorHousingUnit: MatPaginator;
  @ViewChild('TableSortHousingUnit') sortHousingUnit: MatSort;

  pageSize = 10;
  resultSize: number = 0;
  resultSizeWell: number = 0;

  constructor(public dialog: MatDialog,
    public householdService: HouseholdService,
    public housingUnitService: HousingUnitService,
    public oregonWellDataService: OregonWellDataService,
    public authService: AuthService,
    private toastr: ToastrService,
    private sharedService: SharedService,) {
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    if (this.housingUnitId > 0) {
      this.loadHousingUnitAssociations();
    }

    if (this.wellId > 0) {
      this.loadWellHousingUnitAssociations();
    }
  }

  loadHousingUnitAssociations() {
    this.processing = true;
    this.housingUnitService.getHousingUnitAssociations(this.housingUnitId).subscribe(
      result => {
        this.associations = result;
        this.resultSize = this.associations.households.length;
        this.resultSizeWell = this.associations.wells.length;
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.dataSourceHouseholds = new MatTableDataSource<IHousehold>(this.associations.households);
        this.dataSourceHouseholds.paginator = this.paginatorHousehold;
        this.dataSourceHouseholds.sort = this.sortHousehold;

        this.dataSourceWells = new MatTableDataSource<IWellViewModel>(this.associations.wells);
        this.dataSourceWells.paginator = this.paginatorWell;
        this.dataSourceWells.sort = this.sortWell;
      }
    );
  }

  loadWellHousingUnitAssociations() {
    this.processing = true;
    this.associations = this.housingUnitAssocations;

    this.housingUnitService.getWellHousingUnits(this.wellId).subscribe(
      result => {
        this.associations.housingUnits = result;
        this.resultSize = this.associations.housingUnits.length;
        this.resultSizeWell = this.associations.housingUnits.length;
        this.processing = false;
      },
      error => {
        this.processing = false;
      },
      () => {
        this.dataSourceHousingUnits = new MatTableDataSource<IHousingUnit>(this.associations.housingUnits);
        this.dataSourceHousingUnits.paginator = this.paginatorHousingUnit;
        this.dataSourceHousingUnits.sort = this.sortHousingUnit;
      }
    );
  }

  editHousingUnit(id: number) {
    const dialogRef = this.dialog.open(DialogEditHousingUnitComponent, {
      width: '90%',
      data: id,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  editHousehold(id: number) {
    const dialogRef = this.dialog.open(DialogEditHouseholdComponent, {
      width: '90%',
      data: id,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  associateHouseholdToHousingUnit() {
    if(this.housingUnitId <= 0) {
      this.toastr.error('Invalid Housing Unit');
      return;
    }

    let association: HouseholdAssociations = {
      household: null,
      housingUnits: [],
      wells: [],
      householdId: 0,
      housingUnitId: this.housingUnitId,
      housingUnitStartDate: '',
      housingUnitEndDate: '',
      createNewHousingUnit: false,
      createNewHousehold: false,
      newContactName: '',
      newAddress1: '',
      newCity: '',
      newZip: '',
      newCounty: ''
    }

    const dialogRef = this.dialog.open(DialogAssociateHouseholdToHousingUnitComponent, {
      width: '90%',
      data: association,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  associateWellToHousingUnit() {
    if (this.housingUnitId <= 0) {
      this.toastr.error('Invalid Housing Unit');
      return;
    }

    let association: HouseholdAssociation = {
      wellId: 0,
      voucherId: 0,
      householdId: 0,
      housingUnitId: this.housingUnitId,
      housingUnitStartDate: '',
      housingUnitEndDate: ''
    }

    const dialogRef = this.dialog.open(DialogAssociateHousingUnitToWellComponent, {
      width: '90%',
      data: association,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  associateHousingUnitToWell() {
    if (this.wellId <= 0) {
      this.toastr.error('Invalid Well');
      return;
    }

    let association: HouseholdAssociation = {
      wellId: this.wellId,
      voucherId: 0,
      householdId: 0,
      housingUnitId: this.housingUnitId,
      housingUnitStartDate: '',
      housingUnitEndDate: ''
    }

    const dialogRef = this.dialog.open(DialogAssociateHousingUnitToWellComponent, {
      width: '90%',
      data: association,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.load();
    });
  }

  disassociateFromHousingUnit(housingUnitId: number) {
    this.sharedService.openConfirm("Are you sure you want to dissociate this Household and Housing Unit?");
    
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.housingUnitService.disassociateFromHousingUnit(housingUnitId).subscribe(
          result => {
            this.toastr.success('Household and Housing Unit disassociated');
            this.load();
          },
          error => {
            this.toastr.error('Unable to to dissociate this Household and Housing Unit' + error.message);
            this.processing = false;
          }
        );
      }
    });
  }

  disassociateFromWell(wellHousingUnitId: number) {
    this.sharedService.openConfirm("Are you sure you want to dissociate this Housing Unit and Well?");
    
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.housingUnitService.disassociateHousingUnitFromWell(wellHousingUnitId).subscribe(
          result => {
            this.toastr.success('Housing Unit and well disassociated');
            this.load();
          },
          error => {
            this.toastr.error('Unable to to dissociate this Housing Unit and well: ' + error.message);
            this.processing = false;
          }
        );
      }
    });
  }
}